import { AlertIcon } from '@/components/common/AlertIcon';

export function FieldError({ id, message }) {
  if (!message) return null;

  return (
    <p id={id} className="flex items-start gap-1.5 text-sm font-medium text-redline">
      <AlertIcon aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      <span>{message}</span>
    </p>
  );
}